import React, { Fragment, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';


import {
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Button,
    Grid,
    colors
} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 350,
        minHeight: 350
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    },
    fieldset: {
        margin: 15
    }
}));

const Message = ({ item, closeEdition, updateValues, open }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Protocolo {item.code}
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Box
                        display="flex"
                        flexDirection="column"
                        height="100%"
                        justifyContent="center"
                    >
                        <Formik
                            initialValues={item}
                            validationSchema={
                                Yup.object().shape({
                                    name: Yup.string().max(255).required('Nome é obrigatório'),
                                    description: Yup.string().max(255).required('Descrição é o obrigatória'),
                                })
                            }
                            onSubmit={(values, formik) => {
                                updateValues(values);
                                formik.setSubmitting(false);
                            }}
                        >
                            {({
                                errors,
                                handleBlur,
                                handleChange,
                                handleSubmit,
                                isSubmitting,
                                touched,
                                values
                            }) => (
                                <form onSubmit={handleSubmit}>

                                    <Box my={1}></Box>
                                    <Divider />

                                    <Box my={1}>
                                        <Grid container
                                            direction="row"
                                            justify="flex-end"
                                            alignItems="baseline"
                                            spacing={1}  >
                                            <Grid item >
                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting}
                                                    size="small"
                                                    type="submit"
                                                    variant="contained">
                                                    Salvar
                                                </Button>
                                            </Grid>
                                            <Grid item >
                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting}
                                                    size="small"
                                                    variant="contained"
                                                    onClick={() => { closeEdition() }}>
                                                    Cancelar
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Box>

                                </form>
                            )}
                        </Formik>
                    </Box>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Message;
